const Dimension = {
  NAVBAR_HEIGHT: 84,
  TOP_NAVBAR_HEIGHT: 42,
};

export default Dimension;
